import { Injectable } from '@angular/core';
import { AbstractFeatureAclService } from '@y42/feature/acl';
import { Y42FeatureType } from '@y42/json-schema';
import { UiModelingQuery } from '../../state/datasource/ui-modeling.query';

@Injectable({ providedIn: 'root' })
export class UiModelingAclService extends AbstractFeatureAclService<Y42FeatureType.UiModel> {
  constructor(query: UiModelingQuery) {
    super({
      featureType: Y42FeatureType.UiModel,
      query,
    });
  }
}
